import { render } from "./LeadStatusSelect.vue?vue&type=template&id=1b3cc490"
import script from "./LeadStatusSelect.vue?vue&type=script&lang=js"
export * from "./LeadStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__